import { modules } from '@veritone/glc-redux';
import { TDOId } from '@common-modules/universal/models/Brands';
const { auth: authModule, config: configModule } = modules;

// TODO this function is specific to vtn-standard type asset - consider renaming
export const saveAsset: SaveAsset = async (
  { tdoId, email, contentType, type, sourceData, isUserEdited, checkpoint },
  fileData,
  getState
) => {
  const createAssetQuery = `mutation createAsset(
    $tdoId: ID!,
    $type: String,
    $contentType: String,
    $file: UploadedFile,
    $sourceData: SetAssetSourceData,
    $isUserEdited: Boolean
    $email: String
    $checkpoint: Int
  ){
    createAsset( input: {
      containerId: $tdoId,
      type: $type,
      contentType: $contentType,
      sourceData: $sourceData,
      file: $file,
      isUserEdited: $isUserEdited
      details: {email: $email, checkpoint: $checkpoint}
    })
    { id }
  }`;

  const variables = {
    tdoId,
    type,
    contentType,
    file: 'file',
    sourceData,
    isUserEdited: isUserEdited || false,
    email: email || '',
    checkpoint: typeof checkpoint === 'number' ? checkpoint : null,
  };

  const formData = new FormData();
  formData.append('query', createAssetQuery);
  formData.append('variables', JSON.stringify(variables));
  if (contentType === 'application/json') {
    formData.append(
      'file',
      new Blob([JSON.stringify(fileData)], { type: contentType })
    );
  } else {
    formData.append('file', new Blob([fileData], { type: contentType }));
  }
  const config = configModule.getConfig(getState());
  const { apiRoot, graphQLEndpoint, veritoneAppId } = config;
  const graphQLUrl = `${apiRoot}/${graphQLEndpoint}`;
  const token = authModule.selectSessionToken(getState());
  const r = await fetch(graphQLUrl, {
    method: 'post',
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-veritone-application': veritoneAppId,
    },
  });
  // TODO: We should type the possible response here
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const res = await r.json();
  if (res.errors) {
    // TODO: Do we want to always reject with errors?
    // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
    return Promise.reject(res);
  }
  // TODO: We should type the possible response here
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return res;
};

type SaveAsset = (
  a: {
    tdoId: TDOId;
    email?: string;
    checkpoint?: number;
    contentType: string;
    type: string;
    sourceData: {
      engineId: string;
      assetId: string;
    };
    isUserEdited: boolean;
    name?: string;
    width?: number;
    height?: number;
    duration?: number;
  },
  fileData: any,
  getState: () => any
) => Promise<any>;

// -------------- IMAGE-TODO possibly combine these better

export const saveRedactedImageAsset: SaveRedactedImageAsset = async (
  {
    tdoId,
    email,
    contentType,
    type,
    checkpoint,
    version,
    name,
    width,
    height,
    duration,
    metrics,
  },
  fileData,
  getState
) => {
  const createAssetQuery = `mutation createAsset(
    $tdoId: ID!,
    $type: String,
    $contentType: String,
    $file: UploadedFile,
    $name: String
    $details: JSONData
  ){
    createAsset( input: {
      containerId: $tdoId,
      type: $type,
      contentType: $contentType,
      file: $file,
      details: $details
      name: $name
    })
    {
      id
      assetSize
      name
      contentType
      modifiedDateTime
      details
    }
  }`;

  const fileBlob =
    contentType === 'application/json'
      ? new Blob([JSON.stringify(fileData)], { type: contentType })
      : new Blob([fileData], { type: contentType });

  const details: Record<string, unknown> = {
    email: email || '',
    ...(typeof checkpoint === 'number' && { checkpoint }),
    ...(typeof version === 'number' && { version }),
    ...(typeof width === 'number' && { width }),
    ...(typeof height === 'number' && { height }),
    ...(typeof duration === 'number' && { duration }),
    assetSize: fileBlob.size,
    ...(metrics && { metrics }),
    hasVideoRedactions: true,
  };

  const variables = {
    tdoId,
    type,
    contentType,
    file: 'file',
    name: name || null,
    details,
  };

  const formData = new FormData();
  formData.append('query', createAssetQuery);
  formData.append('variables', JSON.stringify(variables));
  formData.append('file', fileBlob);
  const config = configModule.getConfig(getState());
  const { apiRoot, graphQLEndpoint, veritoneAppId } = config;
  const graphQLUrl = `${apiRoot}/${graphQLEndpoint}`;
  const token = authModule.selectSessionToken(getState());
  const r = await fetch(graphQLUrl, {
    method: 'post',
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-veritone-application': veritoneAppId,
    },
  });
  // TODO: We should type the possible response here
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const res = await r.json();
  if (res.errors) {
    // TODO: Do we want to always reject with errors?
    // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
    return Promise.reject(res);
  }
  // TODO: We should type the possible response here
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return res;
};

type SaveRedactedImageAsset = (
  a: {
    tdoId: TDOId;
    email?: string;
    checkpoint?: number;
    version?: number;
    contentType: string;
    type: string;
    name?: string;
    width?: number;
    height?: number;
    duration?: number;
    metrics?: Record<string, unknown>;
  },
  fileData: any,
  getState: () => any
) => Promise<any>;

// Upload a CSV audit log as an asset on the TDO. The asset's details include
// redactedMediaAssetId + version so it can be matched back to the corresponding
// redacted-media asset when one is later deleted.
export const saveAuditLogAsset = async (
  {
    tdoId,
    name,
    redactedMediaAssetId,
    version,
  }: {
    tdoId: TDOId;
    name: string;
    redactedMediaAssetId: string;
    version: number;
  },
  csvContent: string,
  getState: () => any
): Promise<unknown> => {
  const createAssetQuery = `mutation createAuditLogAsset(
    $tdoId: ID!,
    $name: String,
    $file: UploadedFile,
    $redactedMediaAssetId: String,
    $version: Int
  ) {
    createAsset(input: {
      containerId: $tdoId,
      type: "redact-audit-log",
      contentType: "text/csv",
      file: $file,
      name: $name,
      details: {
        redactedMediaAssetId: $redactedMediaAssetId,
        version: $version
      }
    })
    {
      id
      name
      contentType
      # VE-27735: carried on the record injected into state so the audit-log
      # merge can order it against the server's snapshot.
      createdDateTime
      signedUri
      details
    }
  }`;

  const variables = {
    tdoId,
    name,
    file: 'file',
    redactedMediaAssetId,
    version,
  };

  const formData = new FormData();
  formData.append('query', createAssetQuery);
  formData.append('variables', JSON.stringify(variables));
  formData.append('file', new Blob([csvContent], { type: 'text/csv' }));

  const config = configModule.getConfig(getState());
  const { apiRoot, graphQLEndpoint, veritoneAppId } = config;
  const graphQLUrl = `${apiRoot}/${graphQLEndpoint}`;

  const token = authModule.selectSessionToken(getState());
  const r = await fetch(graphQLUrl, {
    method: 'post',
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-veritone-application': veritoneAppId,
    },
  });
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const res = await r.json();
  if (res.errors) {
    // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
    return Promise.reject(res);
  }

  return res;
};
